import PropTypes from 'prop-types';
import React from 'react';
import styled, { withTheme } from 'styled-components';
import { filterToValidAttributes } from '@zocdoc/dom-property';

import { Icon } from '../icons/_base';

const SVG = styled(Icon).attrs({ viewBox: '0 0 243 40' })`
    font-size: ${p => p.height ? `${p.height}px` : '1em'};
    height: 1em;
    width: 6.075em;
`;

class Stars extends React.PureComponent {
    static propTypes = {
        /**
         * any valid number; will be capped to 0 or 5 on either end and rounded to the nearest 0.5
         */
        rating: PropTypes.number.isRequired,

        theme: PropTypes.shape({
            components: PropTypes.shape({
                Stars: PropTypes.shape({
                    /**
                     * the color to be applied to filled-in stars
                     */
                    filledColor: PropTypes.string.isRequired,

                    /**
                     * the color to be applied to empty stars
                     */
                    unfilledColor: PropTypes.string.isRequired,
                }).isRequired,
            }).isRequired,
        }).isRequired,
    };

    render() {
        const { rating, theme: { components: { Stars: { filledColor, unfilledColor } } }, ...props } = this.props;

        const roundedRating = this.round(rating);
        let paths;

        switch (roundedRating) {
            case 5:
                paths = (
                    <g>
                        <path
                            d="M32.2 40l-10.7-7.8L10.8 40l-3.7-2.7 4.1-12.6L.5 17l1.4-4.4h13.2L19.2 0h4.6l4.1 12.6h13.2l1.4 4.4-10.7 7.8 4.1 12.6-3.7 2.6zm50 0l-10.7-7.8L60.8 40l-3.7-2.7 4.1-12.6L50.5 17l1.4-4.4h13.2L69.2 0h4.6l4.1 12.6h13.2l1.4 4.4-10.7 7.8 4.1 12.6-3.7 2.6zm50 0l-10.7-7.8-10.7 7.8-3.7-2.7 4.1-12.6-10.7-7.7 1.4-4.4h13.2L119.2 0h4.6l4.1 12.6h13.2l1.4 4.4-10.7 7.8 4.1 12.6-3.7 2.6zm49.8 0l-10.7-7.8-10.7 7.8-3.7-2.7 4.1-12.6-10.7-7.7 1.4-4.4h13.2L169 0h4.6l4.1 12.6h13.2l1.4 4.4-10.7 7.8 4.1 12.6L182 40zm50.2 0l-10.7-7.8-10.7 7.8-3.7-2.7 4.1-12.6-10.7-7.7 1.4-4.4h13.2L219.2 0h4.6l4.1 12.6h13.2l1.4 4.4-10.7 7.8 4.1 12.6-3.7 2.6z"
                            fill={filledColor}
                        />
                    </g>
                );
                break;

            case 4.5:
                paths = (
                    <g>
                        <path
                            d="M221.5 31.2L210.8 40l-3.7-2.7 4.1-12.6-10.7-7.7 1.4-4.4h13.2L219.2 0h2.9"
                            fill={filledColor}
                        /><path
                            d="M32.2 40l-10.7-7.8L10.8 40l-3.7-2.7 4.1-12.6L.5 17l1.4-4.4h13.2L19.2 0h4.6l4.1 12.6h13.2l1.4 4.4-10.7 7.8 4.1 12.6-3.7 2.6zm50 0l-10.7-7.8L60.8 40l-3.7-2.7 4.1-12.6L50.5 17l1.4-4.4h13.2L69.2 0h4.6l4.1 12.6h13.2l1.4 4.4-10.7 7.8 4.1 12.6-3.7 2.6zm50 0l-10.7-7.8-10.7 7.8-3.7-2.7 4.1-12.6-10.7-7.7 1.4-4.4h13.2L119.2 0h4.6l4.1 12.6h13.2l1.4 4.4-10.7 7.8 4.1 12.6-3.7 2.6zm49.8 0l-10.7-7.8-10.7 7.8-3.7-2.7 4.1-12.6-10.7-7.7 1.4-4.4h13.2L169 0h4.6l4.1 12.6h13.2l1.4 4.4-10.7 7.8 4.1 12.6L182 40z"
                            fill={filledColor}
                        /><path
                            d="M221.5 0h2.3l4.1 12.6h13.2l1.4 4.4-10.7 7.8 4.1 12.6-3.7 2.7-11.3-8.3"
                            fill={unfilledColor}
                        />
                    </g>
                );
                break;

            case 4:
                paths = (
                    <g>
                        <path
                            d="M32.2 40l-10.7-7.8L10.8 40l-3.7-2.7 4.1-12.6L.5 17l1.4-4.4h13.2L19.2 0h4.6l4.1 12.6h13.2l1.4 4.4-10.7 7.8 4.1 12.6-3.7 2.6zm50 0l-10.7-7.8L60.8 40l-3.7-2.7 4.1-12.6L50.5 17l1.4-4.4h13.2L69.2 0h4.6l4.1 12.6h13.2l1.4 4.4-10.7 7.8 4.1 12.6-3.7 2.6zm50 0l-10.7-7.8-10.7 7.8-3.7-2.7 4.1-12.6-10.7-7.7 1.4-4.4h13.2L119.2 0h4.6l4.1 12.6h13.2l1.4 4.4-10.7 7.8 4.1 12.6-3.7 2.6zm49.8 0l-10.7-7.8-10.7 7.8-3.7-2.7 4.1-12.6-10.7-7.7 1.4-4.4h13.2L169 0h4.6l4.1 12.6h13.2l1.4 4.4-10.7 7.8 4.1 12.6L182 40z"
                            fill={filledColor}
                        /><path
                            d="M232.2 40l-10.7-7.8-10.7 7.8-3.7-2.7 4.1-12.6-10.7-7.7 1.4-4.4h13.2L219.2 0h4.6l4.1 12.6h13.2l1.4 4.4-10.7 7.8 4.1 12.6-3.7 2.6z"
                            fill={unfilledColor}
                        />
                    </g>
                );
                break;

            case 3.5:
                paths = (
                    <g>
                        <path
                            d="M171.5 31.2L160.8 40l-3.7-2.7 4.1-12.6-10.7-7.7 1.4-4.4h13.2L169.2 0h2.9"
                            fill={filledColor}
                        /><path
                            d="M32.2 40l-10.7-7.8L10.8 40l-3.7-2.7 4.1-12.6L.5 17l1.4-4.4h13.2L19.2 0h4.6l4.1 12.6h13.2l1.4 4.4-10.7 7.8 4.1 12.6-3.7 2.6zm50 0l-10.7-7.8L60.8 40l-3.7-2.7 4.1-12.6L50.5 17l1.4-4.4h13.2L69.2 0h4.6l4.1 12.6h13.2l1.4 4.4-10.7 7.8 4.1 12.6-3.7 2.6zm50 0l-10.7-7.8-10.7 7.8-3.7-2.7 4.1-12.6-10.7-7.7 1.4-4.4h13.2L119.2 0h4.6l4.1 12.6h13.2l1.4 4.4-10.7 7.8 4.1 12.6-3.7 2.6z"
                            fill={filledColor}
                        /><path
                            d="M232.2 40l-10.7-7.8-10.7 7.8-3.7-2.7 4.1-12.6-10.7-7.7 1.4-4.4h13.2L219.2 0h4.6l4.1 12.6h13.2l1.4 4.4-10.7 7.8 4.1 12.6-3.7 2.6zM171.5 0h2.3l4.1 12.6h13.2l1.4 4.4-10.7 7.8 4.1 12.6-3.7 2.7-11.3-8.3"
                            fill={unfilledColor}
                        />
                    </g>
                );
                break;

            case 3:
                paths = (
                    <g>
                        <path
                            d="M32.2 40l-10.7-7.8L10.8 40l-3.7-2.7 4.1-12.6L.5 17l1.4-4.4h13.2L19.2 0h4.6l4.1 12.6h13.2l1.4 4.4-10.7 7.8 4.1 12.6-3.7 2.6zm50 0l-10.7-7.8L60.8 40l-3.7-2.7 4.1-12.6L50.5 17l1.4-4.4h13.2L69.2 0h4.6l4.1 12.6h13.2l1.4 4.4-10.7 7.8 4.1 12.6-3.7 2.6zm50 0l-10.7-7.8-10.7 7.8-3.7-2.7 4.1-12.6-10.7-7.7 1.4-4.4h13.2L119.2 0h4.6l4.1 12.6h13.2l1.4 4.4-10.7 7.8 4.1 12.6-3.7 2.6z"
                            fill={filledColor}
                        /><path
                            d="M182 40l-10.7-7.8-10.7 7.8-3.7-2.7 4.1-12.6-10.7-7.7 1.4-4.4h13.2L169 0h4.6l4.1 12.6h13.2l1.4 4.4-10.7 7.8 4.1 12.6L182 40zm50.2 0l-10.7-7.8-10.7 7.8-3.7-2.7 4.1-12.6-10.7-7.7 1.4-4.4h13.2L219.2 0h4.6l4.1 12.6h13.2l1.4 4.4-10.7 7.8 4.1 12.6-3.7 2.6z"
                            fill={unfilledColor}
                        />
                    </g>
                );
                break;

            case 2.5:
                paths = (
                    <g>
                        <path
                            d="M121.5 31.2L110.8 40l-3.7-2.7 4.1-12.6-10.7-7.7 1.4-4.4h13.2L119.2 0h2.9"
                            fill={filledColor}
                        /><path
                            d="M32.2 40l-10.7-7.8L10.8 40l-3.7-2.7 4.1-12.6L.5 17l1.4-4.4h13.2L19.2 0h4.6l4.1 12.6h13.2l1.4 4.4-10.7 7.8 4.1 12.6-3.7 2.6zm50 0l-10.7-7.8L60.8 40l-3.7-2.7 4.1-12.6L50.5 17l1.4-4.4h13.2L69.2 0h4.6l4.1 12.6h13.2l1.4 4.4-10.7 7.8 4.1 12.6-3.7 2.6z"
                            fill={filledColor}
                        /><path
                            d="M182 40l-10.7-7.8-10.7 7.8-3.7-2.7 4.1-12.6-10.7-7.7 1.4-4.4h13.2L169 0h4.6l4.1 12.6h13.2l1.4 4.4-10.7 7.8 4.1 12.6L182 40zm50.2 0l-10.7-7.8-10.7 7.8-3.7-2.7 4.1-12.6-10.7-7.7 1.4-4.4h13.2L219.2 0h4.6l4.1 12.6h13.2l1.4 4.4-10.7 7.8 4.1 12.6-3.7 2.6zM121.5 0h2.3l4.1 12.6h13.2l1.4 4.4-10.7 7.8 4.1 12.6-3.7 2.7-11.3-8.3"
                            fill={unfilledColor}
                        />
                    </g>
                );
                break;

            case 2:
                paths = (
                    <g>
                        <path
                            d="M32.2 40l-10.7-7.8L10.8 40l-3.7-2.7 4.1-12.6L.5 17l1.4-4.4h13.2L19.2 0h4.6l4.1 12.6h13.2l1.4 4.4-10.7 7.8 4.1 12.6-3.7 2.6zm50 0l-10.7-7.8L60.8 40l-3.7-2.7 4.1-12.6L50.5 17l1.4-4.4h13.2L69.2 0h4.6l4.1 12.6h13.2l1.4 4.4-10.7 7.8 4.1 12.6-3.7 2.6z"
                            fill={filledColor}
                        /><path
                            d="M132.2 40l-10.7-7.8-10.7 7.8-3.7-2.7 4.1-12.6-10.7-7.7 1.4-4.4h13.2L119.2 0h4.6l4.1 12.6h13.2l1.4 4.4-10.7 7.8 4.1 12.6-3.7 2.6zm49.8 0l-10.7-7.8-10.7 7.8-3.7-2.7 4.1-12.6-10.7-7.7 1.4-4.4h13.2L169 0h4.6l4.1 12.6h13.2l1.4 4.4-10.7 7.8 4.1 12.6L182 40zm50.2 0l-10.7-7.8-10.7 7.8-3.7-2.7 4.1-12.6-10.7-7.7 1.4-4.4h13.2L219.2 0h4.6l4.1 12.6h13.2l1.4 4.4-10.7 7.8 4.1 12.6-3.7 2.6z"
                            fill={unfilledColor}
                        />
                    </g>
                );
                break;

            case 1.5:
                paths = (
                    <g>
                        <path
                            d="M71.5 31.2L60.8 40l-3.7-2.7 4.1-12.6L50.5 17l1.4-4.4h13.2L69.2 0h2.9"
                            fill={filledColor}
                        /><path
                            d="M32.2 40l-10.7-7.8L10.8 40l-3.7-2.7 4.1-12.6L.5 17l1.4-4.4h13.2L19.2 0h4.6l4.1 12.6h13.2l1.4 4.4-10.7 7.8 4.1 12.6-3.7 2.6z"
                            fill={filledColor}
                        /><path
                            d="M132.2 40l-10.7-7.8-10.7 7.8-3.7-2.7 4.1-12.6-10.7-7.7 1.4-4.4h13.2L119.2 0h4.6l4.1 12.6h13.2l1.4 4.4-10.7 7.8 4.1 12.6-3.7 2.6zm49.8 0l-10.7-7.8-10.7 7.8-3.7-2.7 4.1-12.6-10.7-7.7 1.4-4.4h13.2L169 0h4.6l4.1 12.6h13.2l1.4 4.4-10.7 7.8 4.1 12.6L182 40zm50.2 0l-10.7-7.8-10.7 7.8-3.7-2.7 4.1-12.6-10.7-7.7 1.4-4.4h13.2L219.2 0h4.6l4.1 12.6h13.2l1.4 4.4-10.7 7.8 4.1 12.6-3.7 2.6zM71.5 0h2.3l4.1 12.6h13.2l1.4 4.4-10.7 7.8 4.1 12.6-3.7 2.6-11.3-8.3"
                            fill={unfilledColor}
                        />
                    </g>
                );
                break;

            case 1:
                paths = (
                    <g>
                        <path
                            d="M32.2 40l-10.7-7.8L10.8 40l-3.7-2.7 4.1-12.6L.5 17l1.4-4.4h13.2L19.2 0h4.6l4.1 12.6h13.2l1.4 4.4-10.7 7.8 4.1 12.6-3.7 2.6z"
                            fill={filledColor}
                        /><path
                            d="M82.2 40l-10.7-7.8L60.8 40l-3.7-2.7 4.1-12.6L50.5 17l1.4-4.4h13.2L69.2 0h4.6l4.1 12.6h13.2l1.4 4.4-10.7 7.8 4.1 12.6-3.7 2.6zm50 0l-10.7-7.8-10.7 7.8-3.7-2.7 4.1-12.6-10.7-7.7 1.4-4.4h13.2L119.2 0h4.6l4.1 12.6h13.2l1.4 4.4-10.7 7.8 4.1 12.6-3.7 2.6zm49.8 0l-10.7-7.8-10.7 7.8-3.7-2.7 4.1-12.6-10.7-7.7 1.4-4.4h13.2L169 0h4.6l4.1 12.6h13.2l1.4 4.4-10.7 7.8 4.1 12.6L182 40zm50.2 0l-10.7-7.8-10.7 7.8-3.7-2.7 4.1-12.6-10.7-7.7 1.4-4.4h13.2L219.2 0h4.6l4.1 12.6h13.2l1.4 4.4-10.7 7.8 4.1 12.6-3.7 2.6z"
                            fill={unfilledColor}
                        />
                    </g>
                );
                break;

            case 0.5:
                paths = (
                    <g>
                        <path
                            d="M21.5 31.2L10.8 40l-3.7-2.7 4.1-12.6L.5 17l1.4-4.4h13.2L19.2 0h2.9"
                            fill={filledColor}
                        /><path
                            d="M82.2 40l-10.7-7.8L60.8 40l-3.7-2.7 4.1-12.6L50.5 17l1.4-4.4h13.2L69.2 0h4.6l4.1 12.6h13.2l1.4 4.4-10.7 7.8 4.1 12.6-3.7 2.6zm50 0l-10.7-7.8-10.7 7.8-3.7-2.7 4.1-12.6-10.7-7.7 1.4-4.4h13.2L119.2 0h4.6l4.1 12.6h13.2l1.4 4.4-10.7 7.8 4.1 12.6-3.7 2.6zm49.8 0l-10.7-7.8-10.7 7.8-3.7-2.7 4.1-12.6-10.7-7.7 1.4-4.4h13.2L169 0h4.6l4.1 12.6h13.2l1.4 4.4-10.7 7.8 4.1 12.6L182 40zm50.2 0l-10.7-7.8-10.7 7.8-3.7-2.7 4.1-12.6-10.7-7.7 1.4-4.4h13.2L219.2 0h4.6l4.1 12.6h13.2l1.4 4.4-10.7 7.8 4.1 12.6-3.7 2.6zM21.5 0h2.3l4.1 12.6h13.2l1.4 4.4-10.7 7.8 4.1 12.6-3.7 2.6-11.3-8.3"
                            fill={unfilledColor}
                        />
                    </g>
                );
                break;

            default:
                paths = (
                    <g>
                        <path
                            d="M32.2 40l-10.7-7.8L10.8 40l-3.7-2.7 4.1-12.6L.5 17l1.4-4.4h13.2L19.2 0h4.6l4.1 12.6h13.2l1.4 4.4-10.7 7.8 4.1 12.6-3.7 2.6zm50 0l-10.7-7.8L60.8 40l-3.7-2.7 4.1-12.6L50.5 17l1.4-4.4h13.2L69.2 0h4.6l4.1 12.6h13.2l1.4 4.4-10.7 7.8 4.1 12.6-3.7 2.6zm50 0l-10.7-7.8-10.7 7.8-3.7-2.7 4.1-12.6-10.7-7.7 1.4-4.4h13.2L119.2 0h4.6l4.1 12.6h13.2l1.4 4.4-10.7 7.8 4.1 12.6-3.7 2.6zm49.8 0l-10.7-7.8-10.7 7.8-3.7-2.7 4.1-12.6-10.7-7.7 1.4-4.4h13.2L169 0h4.6l4.1 12.6h13.2l1.4 4.4-10.7 7.8 4.1 12.6L182 40zm50.2 0l-10.7-7.8-10.7 7.8-3.7-2.7 4.1-12.6-10.7-7.7 1.4-4.4h13.2L219.2 0h4.6l4.1 12.6h13.2l1.4 4.4-10.7 7.8 4.1 12.6-3.7 2.6z"
                            fill={unfilledColor}
                        />
                    </g>
                );
                break;
        }

        return (
            <SVG
                {...filterToValidAttributes(props)}
                data-rating={roundedRating}
                xmlns="http://www.w3.org/2000/svg"
            >
                {paths}
            </SVG>
        );
    }

    round(rating) {
        const rounded = Math.round(rating * 2) / 2;

        if (rounded < 0) {
            return 0;
        } else if (rounded > 5) {
            return 5;
        } else {
            return rounded;
        }
    }
}

export default withTheme(Stars);
